import type { BetterstartConfig } from '@cli-types/core-engine/config.js'

export function defineConfig(config: BetterstartConfig): BetterstartConfig {
  return config
}
